import {FC} from 'react';
import {WebviewProps} from './Webview.definition';

export const Webview: FC<WebviewProps> = () => null;
